import { Card, Checkbox, IOption, Select } from '@ss/meta-core-components'
import { config } from '../../config'
import React from 'react'
import { IGenericObject } from '@types'
import styled from '@emotion/styled'

interface Props {
  setFilters: React.Dispatch<
    React.SetStateAction<IGenericObject<IOption | null>>
  >
}

/**
 * Componente Filtri per la pagina Start up comparison
 * @param setFilters {React.Dispatch<React.SetStateAction<IGenericObject<IOption | null>>>}
 * @component
 */
export const Filters: React.FC<Props> = ({ setFilters }) => {
  return (
    <Card width={'100%'}>
      <FilterContainer data-cy={'comparison-filters'}>
        <InputContainer>
          <InputLabel>Attributo</InputLabel>
          <Select
            dataCy={'field'}
            options={config.filters.attributes}
            onChange={(options) => {
              setFilters((filters) => ({
                ...filters,
                field: options?.[0] ? options?.[0] : null,
              }))
            }}
          />
        </InputContainer>
        <InputContainer>
          <InputLabel>Anno</InputLabel>
          <Select
            dataCy={'year'}
            options={config.filters.comparisonYear}
            onChange={(options) => {
              setFilters((filters) => ({
                ...filters,
                anno: options?.[0] ? options?.[0] : null,
              }))
            }}
          />
        </InputContainer>
        <InputContainer>
          <InputLabel>Aggregazione</InputLabel>
          <Select
            dataCy={'aggregation'}
            options={config.filters.aggregations}
            onChange={(options) => {
              setFilters((filters) => ({
                ...filters,
                aggregation: options?.[0] ? options?.[0] : null,
              }))
            }}
          />
        </InputContainer>
      </FilterContainer>
    </Card>
  )
}

//region style
const FilterContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;
`
const InputContainer = styled.div`
  display: grid;
  grid-template-columns: 150px auto;
  gap: 10px;
`
const InputLabel = styled.div`
  place-self: center;
`
//endregion
